import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, LockIcon, GlobeIcon, CheckIcon, ZapIcon, SparklesIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from './constants';
const comboIncludes = ['Component 1 — Hip Hop Foundations, Grooves & Body Control (25 classes)', 'Component 2 — Hip Hop Footwork, Steps & Skill Progressions (25 classes)', 'Component 3 — Hip Hop Combinations, Freestyle & Choreography (25 classes)', 'Component 4 — Hip Hop Performance, Class Planning & Instructor System (25 classes)', 'Component 5 — The 5 Strategic Bonuses (Cueing Library + Mixed-Level System + Warm-Up Vault + Activity Bank + Emergency Classes)', 'Component 6 — The Full Instructor Toolkit (Class Finder + Planners + Trackers + Evaluation Tools)', '7-day money-back guarantee'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream-dark border-y border-line relative" data-id="element-193" data-mp="7utl80am8wp8">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-194" data-mp="1mgy3swazncoz">
        <div className="text-center mb-10" data-id="element-195" data-mp="1mihor07labx3">
          <h2 className="text-3xl md:text-5xl font-serif font-bold uppercase mb-3 text-ink" data-id="element-196" data-mp="1howy5t8bsk7x">
            Your complete offer today
          </h2>
          <p className="text-burgundy text-sm md:text-base font-semibold" data-id="element-197" data-mp="1cosc7nonexab">
            The complete 6-in-1 teaching system — ready for your next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream-light border-2 border-burgundy rounded-3xl p-1 relative shadow-[0_16px_40px_rgba(26,26,26,0.12)]" data-id="element-198" data-mp="25f0r96nw11ko">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-burgundy text-cream-light font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-199" data-mp="1rezn9icbte0z">
            <SparklesIcon size={14} data-id="element-200" data-mp="fzb1uveq0n2a" /> Complete Package
          </div>

          <div className="bg-cream-light rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-201" data-mp="hit71aue0093">
            <h3 className="text-2xl md:text-3xl font-serif font-bold uppercase text-burgundy mb-3" data-id="element-202" data-mp="mh4fbh51a2p7">
              Hip Hop Dance Instructor Ready™
            </h3>
            <p className="text-base text-ink-soft mb-6" data-id="element-203" data-mp="7ly5sk6qblr4">
              Everything you need to teach hip hop dance with confidence — all
              in one place.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream border border-gold/60 rounded-xl p-4" data-id="element-204" data-mp="3uvcy5xhr7f46">
              {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-ink-soft" data-id="element-205" data-mp="3kzjja7gkb9j8" data-mpi={i}>
                  <CheckIcon size={16} className="text-burgundy shrink-0 mt-0.5" data-id="element-206" data-mp="3pvgtdw18fjnk" />
                  <span data-id="element-207" data-mp="3byll45st1w8k">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-208" data-mp="3fyvsnmw8wupj">
              <span className="text-lg text-ink-muted line-through block mb-1" data-id="element-209" data-mp="2xb3doznuynig">
                $105.00 USD
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-210" data-mp="2scs3uoxkcd08">
                <span className="text-2xl md:text-3xl text-ink" data-id="element-211" data-mp="36brtnzwtaxxz">TODAY:</span>
                <span className="text-4xl md:text-5xl font-serif font-bold text-burgundy" data-id="element-212" data-mp="369ouap9rrsgl">
                  $27.00 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-213" data-mp="3g8edqmhbdkyy">
              🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-ink-muted mb-4" data-id="element-214" data-mp="3l1h6ise9oqe3">
              <span className="flex items-center gap-1.5" data-id="element-215" data-mp="2syj7vzbyp81">
                <LockIcon size={12} className="text-burgundy" data-id="element-216" data-mp="3u2f3wru79znp" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-217" data-mp="hx1biwktdijl">
                <ZapIcon size={12} className="text-burgundy" data-id="element-218" data-mp="lzo5b311pdjf" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-219" data-mp="qqeaaf5k7edl">
                <ShieldIcon size={12} className="text-burgundy" data-id="element-220" data-mp="qqxts0auyatq" /> 7-day
                guarantee
              </span>
            </div>

            <div className="bg-cream border border-line rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-221" data-mp="3v4m8uu8i1ldl">
              <GlobeIcon className="text-burgundy shrink-0 mt-0.5" size={14} data-id="element-222" data-mp="301uki42odcg" />
              <p className="text-[11px] text-ink-muted leading-snug" data-id="element-223" data-mp="806d0dojji5b">
                Pay in your local currency. The amount adjusts automatically
                based on your country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}